export const EXCEL_BUILTIN_SHORT_DATE = "mm-dd-yy"

const fractionDigits = (decimals: number) => (decimals > 0 ? `.${"0".repeat(decimals)}` : "")

export const groupedNumberFormat = (decimals: number) => `#,##0${fractionDigits(decimals)}`

export const excelNumberCellClass = (percentage: boolean) =>
  percentage ? "percentType" : "numberType"

export const numberExcelStyles = (decimals: number) => [
  { id: "numberType", numberFormat: { format: groupedNumberFormat(decimals) } },
  { id: "percentType", numberFormat: { format: `0${fractionDigits(decimals)}%` } },
]
